import React from "react";
import SDK from "../../SDK";
import { toast } from "react-toastify";
import { store } from "../../Redux/store";
import { hideModal } from "../../Redux/feature/popUpDataSlice";
import { blockOfflineAction, isAppOnline } from "../../Helpers/Utility";
import OutsideClickHandler from "react-outside-click-handler";

const ActionPopUp = (props) => {

    const { modalProps: { title = "", activeclass = "", action = "" ,  
    displayName = "", groupuniqueId = "", userjid = "" , checkAdmin = ""} = {} } = props  

    const cancelAction = () => {
        store.dispatch(hideModal())
    }

    const handleAction = () => {
        if (!isAppOnline()) {
            blockOfflineAction()
            return
        }
        if (action === 'groupMakeAdmin') {
            SDK && SDK.makeAsAdmin(groupuniqueId, userjid)
            const toastMessage = `${displayName} is now admin`;
            toast.success(toastMessage, "success");
        } else if (action === "ExitGroup") {
            SDK && SDK.userExitGroup(groupuniqueId, userjid, checkAdmin);
            const toastMessage = `You’re no longer participant in the group`;
            toast.info(toastMessage);
        }
        else {
            SDK && SDK.removeParticipant(groupuniqueId, userjid, !!checkAdmin)
            const toastMessage = `${displayName} is removed from group`
            toast.success(toastMessage);
        }
        setTimeout(()=>{
            cancelAction()
        },10)
    }

    const ternaryAvoid = () => {
        switch (action) {
            case 'groupMakeAdmin':
                return 'Make group admin'
            case 'ExitGroup':
                return 'Exit'
            case 'DeleteGroup':
                return 'Delete'
            default:
                return 'Remove'
        }
    }

    const labelToDisplay = ternaryAvoid();

    return (
        <div className="popup-wrapper">
            <div className={`popup-container ${activeclass}`}>
            <OutsideClickHandler onOutsideClick={() => cancelAction()} >
                <div className="popup-container-inner">
                    <div className="popup-label">
                        <label>{title}</label>
                    </div>
                    <div className="popup-noteinfo">
                        <button
                            type="button"
                            className="btn-cancel"
                            onClick={cancelAction}
                            data-jest-id={"jestcancelAction"}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleAction}
                            data-jest-id={"jesthandleAction"}
                            className={`btn-active ${action === 'groupRemoveMember' ? "danger" : ""}`}
                        >
                            {labelToDisplay}
                        </button>
                    </div>
                </div>
            </OutsideClickHandler>
            </div>
    </div>
    )
};

export default ActionPopUp;
